/**
 * Configuration for API endpoints that switches between production and development environments
 */

import { supabase } from '@/integrations/supabase/client'

// Base API URLs

const isDevelopment =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export const API_BASE_URL = isDevelopment
  ? 'http://127.0.0.1:8000'
  : 'https://mavi-api.novaforge.tech'

export async function authedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  const token = session?.access_token
  if (!token) {
    throw new Error('No Supabase access token found')
  }

  const isFormData = options.body instanceof FormData

  const headers: HeadersInit = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
  }

  return fetch(url, {
    ...options,
    headers,
  })
}
